import React, { useEffect, useRef } from 'react';
import LinkedInHeader from './LinkedInHeader';
import './LinkedInTheme.css';
import { Eye, CheckCircle, MessageSquare } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';

const Accessibility = () => {
  const { t } = useTranslation();
  const headingRef = useRef(null);

  useEffect(() => {
    document.title = `${t('accessibility.title')} | POD+`;
    // Move focus to the main heading for screen readers
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [t]);

  return (
    <main className="li-centered-container">
            
            <div className="li-card" style={{ padding: '40px 24px' }}>
                <h1 
                    ref={headingRef} 
                    tabIndex="-1" 
                    style={{ fontSize: '32px', fontWeight: '200', color: 'rgba(0,0,0,0.9)', marginBottom: '24px', borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', outline: 'none' }}
                >
                    {t('accessibility.title')}
                </h1>

                <section style={{ marginBottom: '32px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <Eye size={24} color="#0a66c2" aria-hidden="true" />
                        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{t('accessibility.commitment.title')}</h2>
                    </div>
                    <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)' }}>
                        {t('accessibility.commitment.text')}
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <CheckCircle size={24} color="#057642" aria-hidden="true" />
                        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{t('accessibility.conformance.title')}</h2>
                    </div>
                    <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)', marginBottom: '16px' }}>
                        {t('accessibility.conformance.text1')}
                    </p>
                    <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)' }}>
                        <Trans i18nKey="accessibility.conformance.text2">
                            POD+ is partially conformant with <strong>WCAG 2.1 Level AA</strong>. Partially conformant means that some parts of the content do not fully conform to the accessibility standard. We are actively working to address these areas.
                        </Trans>
                    </p>
                    <ul style={{ paddingLeft: '24px', marginTop: '16px', color: 'rgba(0,0,0,0.75)' }}>
                        <li style={{ marginBottom: '8px' }}>{t('accessibility.conformance.list.item1')}</li>
                        <li style={{ marginBottom: '8px' }}>{t('accessibility.conformance.list.item2')}</li>
                        <li style={{ marginBottom: '8px' }}>{t('accessibility.conformance.list.item3')}</li>
                    </ul>
                </section>

                <section>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <MessageSquare size={24} color="#7c3aed" aria-hidden="true" />
                        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{t('accessibility.feedback.title')}</h2>
                    </div>
                    <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)', marginBottom: '16px' }}>
                        {t('accessibility.feedback.text')}
                    </p>
                    <div style={{ backgroundColor: '#f9fafb', padding: '16px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                        <p style={{ margin: 0, fontWeight: '600' }}>{t('accessibility.feedback.emailLabel')} <a href="mailto:accessibility@gclouds.co.uk" style={{ color: '#0a66c2', textDecoration: 'none' }}>accessibility@gclouds.co.uk</a></p>
                        <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#666' }}>{t('accessibility.feedback.response')}</p>
                    </div>
                </section>

            </div>
    </main>
  );
};

export default Accessibility;
